import { OnboardingStep } from "@/components/Onboarding/constants";
import {
  Action,
  ControlType,
  useOnboardingAnalytics,
} from "@/context/AnalyticsProvider";
import { useCallback, useState } from "react";
import { useFeatureFlags } from "./useFeatureFlags";

export const useOnboardingModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { onboardingModalOct25 } = useFeatureFlags();
  const { track } = useOnboardingAnalytics();

  const triggerOnboarding = useCallback(() => {
    setIsModalOpen(true);
    track({
      action: Action.PRESSED,
      extras: {
        id: OnboardingStep.ONBOARDING_MODAL,
        control: "sign-in",
        controlType: ControlType.BUTTON,
      },
    });
  }, [track]);

  return {
    isModalOpen,
    setIsModalOpen,
    isOnboardingModalEnabled: onboardingModalOct25,
    triggerOnboarding,
  };
};
